import React from 'react'
import './ProfileOutlet.scss'
import ProfileSidebar from '../ProfileSidebar/ProfileSidebar'
import { Outlet, useLocation } from 'react-router-dom'

const ProfileOutlet = () => {
    const location = useLocation();
    const isPersonalDetails = location.pathname === '/profile' || location.pathname === '/profile/personal_details';

    return (
        <div className='profileoutlet_container'>
            {!isPersonalDetails && <ProfileSidebar />}
            <Outlet />
        </div>
    )
}

export default ProfileOutlet